/**
 * @type { { logError: (args: { error?: { stack?: string }; message?: string; }) => Promise<void>; logWarning: (args: { message: any; }) => Promise<void>; logDebug: (args: { message: any; }) => Promise<void>; logInfo: (args: { message: any; }) => Promise<void>; log: (args: { message: any; }) => Promise<void>; } }
 * */
module.exports = require('./src/index');
